import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, filter, map } from 'rxjs';

import { CoreModuleName } from '@app/core/models/core-constant.model';
import { EidosConfigService } from '@common/config/eidos-config.service';
import { IEidosModuleConfiguration } from '@common/config/environment.interface';
import { DynamicApiResponse } from '@common/models/dynamic-api-response.model';
import { CoreFormatService } from '@common/services/core-format.service';
import { EidosBaseApiService } from '@common/services/eidos-base-api.service';
import { EidosLogService } from '@common/services/eidos-log.service';
import { EidosSecurityService } from '@common/services/eidos-security.service';

import { IReservationModuleAPIConfiguration } from '@app/res-common/models/rescom.model';
import { IReservationApiDeclineInsurance, ResInsurance } from '../models/res-insurance.model ';

@Injectable({
  providedIn: 'root'
})
export class ReservationInsuranceApiService extends EidosBaseApiService {

  constructor(
    public configService: EidosConfigService,
    public eidosSecurityService: EidosSecurityService,
    public http: HttpClient,
    public eidosLogService: EidosLogService,
    public domSanitizer: DomSanitizer,
    public coreFormatService: CoreFormatService
  ) {
    super(coreFormatService, configService, eidosLogService, eidosSecurityService, http);
    this.configService.currentModulesConfig
      .pipe(
        filter(
          (modules: Array<IEidosModuleConfiguration>) => !!modules.find((module) => module.moduleName === CoreModuleName.Reservation)
        )
      )
      .subscribe((modules) => {
        const module = modules.find((module) => module.moduleName === CoreModuleName.Reservation);
        if (module) {
          const reservationModuleAPI = module.API as IReservationModuleAPIConfiguration;
          this.urlAPI = reservationModuleAPI.url;
          this.staticUrlAPI = reservationModuleAPI.staticUrl;
          this.pluginUrlAPI = reservationModuleAPI.pluginUrl;
          this.apiVersion = reservationModuleAPI.version;
          if (reservationModuleAPI.headers) {
            this.headers = {
              ...reservationModuleAPI.headers,
              ...this.headers
            };
          }
        }
      });
  }

  public declineInsurance(params?: IReservationApiDeclineInsurance): Observable<any> {
    return this.postDynamicAPI('insurance/decline', params);
  }

  public getBookedInsurances(params: { bkgID: number, action: string }): Observable<ResInsurance[]> {
    return this.getDynamicAPI('booking/getInsuranceBooked', {
      BkgID: params.bkgID,
      Action: params.action
    }).pipe(
      map<DynamicApiResponse, ResInsurance[]>((response) => {
        return response.body.map((i: any) => new ResInsurance(i));
      })
    );
  }

  public getInsurances(params: { bkgID: number }): Observable<any[]> {
    return this.callDynamicAPI('insurance/select', { BkgID: params.bkgID, Action: 'Get' }).pipe(
      map<DynamicApiResponse, Array<any>>((response) => {
        return response.body.map((i: any) => new ResInsurance(i));
      })
    );
  }
}
